import React, { Component } from 'react';
// import OrgChart from './orgchart'
import OrgChart from "@balkangraph/orgchart.js";



OrgChart.templates.myTemplate = Object.assign({}, OrgChart.templates.rony);
OrgChart.templates.myTemplate.size = [240, 280]
OrgChart.templates.myTemplate.node = '<rect filter="url(#{randId})" x="0" y="0" height="280" width="240" fill="#FFF" stroke="#FFFFFF"  stroke-width="1" rx="5" ry="5"></rect>'
OrgChart.templates.myTemplate.svg =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background-color:#00007d;display:block;" '
    + 'width="{w}" height="{h}" viewBox="{viewBox}">{content}</svg>';

OrgChart.templates.myTemplate.defs =
    '<filter id="{randId}" x="0" y="0" width="200%" height="200%">'
    + '<feOffset result="offOut" in="SourceAlpha" dx="2" dy="2"></feOffset>'
    + '<feGaussianBlur result="blurOut" in="offOut" stdDeviation="5"></feGaussianBlur>'
    + '<feBlend in="SourceGraphic" in2="blurOut" mode="normal"></feBlend>'
    + '</filter>';

OrgChart.templates.myTemplate.ripple = {
    color: "#00007d",
    radius: 5,
    rect: null
};

// OrgChart.templates.myTemplate.img_1 = '<clipPath id="ulaImg1"><circle cx="6" cy="7" r="200"></circle></clipPath><image style="z-index: 1000" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg1)" xlink:href="{val}" x="65" y="45" opacity="1"  width="110" height="110"></image>';
// OrgChart.templates.myTemplate.img_1 = '<clipPath id="ulaImg1"><circle cx="50" cy="130" r="200"></circle></clipPath><image style="z-index: 1000" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg1)" xlink:href="{val}" x="52" y="140" opacity=".3"  width="140" height="140"></image>';
OrgChart.templates.myTemplate.img_1 = '<clipPath id="ulaImg1"><rect x="0" y="0" height="280" width="240" ></rect></clipPath><image style="z-index: 1000" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg1)" xlink:href="{val}" x="-190" y="40" opacity=".2"  width="300" height="300"></image>';
OrgChart.templates.myTemplate.img_0 = '<clipPath id="ulaImg"><circle cx="95" cy="100" r="100"></circle></clipPath><image style="z-index: 1000" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="85" y="70" opacity="1"  width="70" height="70"></image>';
OrgChart.templates.myTemplate.field_0 = '<text style="font-size: 14px; font-weight: 800; vertical-align: middle"  data-text-overflow="multiline" data-width="220" fill="#00007d" x="120" y="40" text-anchor="middle" >{val}</text>';
OrgChart.templates.myTemplate.field_1 = '<text style="font-size: 14px; font-weight: 800"  data-text-overflow="multiline" data-width="180" fill="#000" x="120" y="180" text-anchor="middle" >{val}</text>';
OrgChart.templates.myTemplate.field_5 = '<text style="font-size: 14px; font-weight: 800"  data-text-overflow="multiline" data-width="180" fill="#000" x="120" y="200" text-anchor="middle" >{val}</text>'
OrgChart.templates.myTemplate.field_2 = '<text style="font-size: 14px;"  data-text-overflow="multiline" data-width="200" fill="#000" x="120" y="220" text-anchor="middle" >Plazas: {val}</text>';
OrgChart.templates.myTemplate.field_3 = '<text style="font-size: 14px;"  data-text-overflow="multiline" data-width="200" fill="#000" x="120" y="240" text-anchor="middle" >{val}</text>';
OrgChart.templates.myTemplate.field_4 = '<text style="font-size: 14px;"  data-text-overflow="multiline" data-width="200" fill="#000" x="120" y="260" text-anchor="middle" >{val}</text>'
OrgChart.templates.myTemplate.link = '<path stroke="#FFFFFF" stroke-width="1px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" style="z-index:10" />';

OrgChart.MIXED_LAYOUT_ALL_NODES = true;
OrgChart.miniMap.padding = 10;
OrgChart.miniMap.position = {
    top: 'padding',
    left: 'padding',
    right: undefined,
    bottom: undefined
};

OrgChart.templates.myTemplate.nodeMenuButton =
    '<g style="cursor:pointer;" transform="matrix(1,0,0,1,155,235)" data-ctrl-n-menu-id="{id}">'
    + '<rect x="-4" y="-10" fill="#000000" fill-opacity="0" width="22" height="22"></rect>'
    + '<circle cx="0" cy="0" r="2" fill="#F57C00"></circle>'
    + '<circle cx="7" cy="0" r="2" fill="#F57C00"></circle>'
    + '<circle cx="14" cy="0" r="2" fill="#F57C00"></circle>'
    + '</g>';
OrgChart.templates.myTemplate.plus =
    '<rect x="0" y="0" width="36" height="36" rx="12" ry="12" fill="#808080" stroke="#FFF" stroke-width="1"></rect>'
    + '<line x1="4" y1="18" x2="32" y2="18" stroke-width="1" stroke="#FFF"></line>'
    + '<line x1="18" y1="4" x2="18" y2="32" stroke-width="1" stroke="#FFF"></line>'
OrgChart.templates.myTemplate.minus =
    '<rect x="0" y="0" width="36" height="36" rx="12" ry="12" fill="#808080" stroke="#FFF" stroke-width="1"></rect>'
    + '<line x1="4" y1="18" x2="32" y2="18" stroke-width="1" stroke="#FFF"></line>'

export default class Chart extends Component {

    constructor(props) {
        super(props);
        this.divRef = React.createRef();
    }

    shouldComponentUpdate() {
        return false;
    }


    componentDidMount() {
        // OrgChart.templates.myTemplate = Object.assign({}, OrgChart.templates.belinda);
        this.chart = new OrgChart(this.divRef.current, {
            nodes: this.props.nodes,
            template: "myTemplate",
            layout: OrgChart.treeRightOffset,
            mouseScrool: OrgChart.action.none,
            scaleInitial: OrgChart.match.boundary,
            // mode: 'dark',
            // enableSearch: false,
            // showXScroll: true,
            editForm: {
                readOnly: true
            },
            padding: 20,
            miniMap: true,
            keyNavigation: true,
            enableDragDrop: true,
            nodeBinding: {
                img_1: 'Logo',
                img_0: 'img',
                field_0: 'Nombre',
                field_1: 'Cargo',
                field_2: 'Cantidad',
                field_3: 'Tipo',
                field_4: 'Planilla',
                field_5: 'Departamento',
            },

            menu: {
                pdf: { text: "Export PDF" },
                png: { text: "Export PNG" },
                svg: { text: "Export SVG" },
                csv: { text: "Export CSV" },
                // export_pdf: { text: "Export PDF", icon: OrgChart.icon.pdf(24, 24, "#7A7A7A"), onClick: pdf },
            },
            toolbar: {
                layout: true,
                zoom: true,
                fit: true,
                expandAll: true,
            },

            // nodeMenu:{
            //     details: {text:"Details"},
            //     edit: {text:"Edit"},
            //     add: {text:"Add"},
            //     remove: {text:"Remove"}
            // },
            tags: {
                "subLevels0": {
                    subLevels: 0
                },
                "subLevels1": {
                    subLevels: 1
                },
                "subLevels2": {
                    subLevels: 2
                },
                "subLevels3": {
                    subLevels: 3
                },
                "subLevels4": {
                    subLevels: 4
                },
                "subLevels5": {
                    subLevels: 5
                },
                "subLevels6": {
                    subLevels: 6
                },
                "subLevels7": {
                    subLevels: 7
                },
                "subLevels8": {
                    subLevels: 8
                },
                "subLevels9": {
                    subLevels: 9
                },
            },
        });

        function pdf(nodeId) {
            this.chart.exportPDF({
                format: "A4",
                header: 'My Header',
                footer: 'My Footer. Page {current-page} of {total-pages}'
            });
        }

    }

    render() {
        return (
            <div id="tree" ref={this.divRef} style={{ height: '95vh', background: '#FFF' }}></div>
        );
    }
}